<template>
  <div>
    <svg
      v-if="name === 'tele2'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="12"
        fill="#1A1A18"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.3578 8.59037V9.99934C19.2635 9.99934 19.0287 10.9387 18.5926 11.4754C18.5255 11.5425 18.4584 11.6096 18.3913 11.7102C18.3242 11.7773 18.2571 11.8444 18.19 11.9115C17.9552 12.1799 17.6197 12.4818 17.3514 12.7502C17.2172 12.8844 17.0495 13.0186 16.9488 13.1528L16.5127 13.5553L18.6262 13.4882C18.6933 13.4211 18.7268 13.3876 18.7603 13.354L19.0287 13.0521C19.1629 12.8844 19.4313 12.616 19.5655 12.4483C19.599 12.3812 19.6326 12.3476 19.6997 12.2805C20.4041 11.3748 20.9074 10.0329 20.0687 9.06002C19.6326 8.62391 18.9616 8.52327 18.3578 8.59037Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.4531 9.59681V15.1656H13.7279V9.42908L12.4531 9.59681Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.2441 13.8238V15.1656H20.5717V13.6896L16.2441 13.8238Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.23278 10.0664L9.19922 15.1655H10.3063V9.89862L9.23278 10.0664Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.28027 10.469V15.1656H7.25314V10.3348L6.28027 10.469Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.3103 11.3748L17.6522 11.2406C17.6522 10.8716 17.5851 10.2342 18.1218 10.0665V8.62396C16.78 8.82524 16.1761 10.1336 16.3103 11.3748Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.23366 11.9115C4.20011 12.1127 4.23366 13.2533 4.23366 13.5553C4.23366 14.092 4.20011 14.6623 4.23366 15.1991H5.13943V11.8444L4.23366 11.9115Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.42871 10.9053V11.8446L5.94474 11.5762V10.5363L3.42871 10.9053Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.9959 13.8906C13.9623 13.9912 13.9623 14.9976 13.9959 15.1654H15.8409V13.8235L13.9959 13.8906Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.9629 9.36185V10.6702L15.8415 10.4689V9.12701L13.9629 9.36185Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5073 13.9915V15.1656H12.1176V13.9579L10.5073 13.9915Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.9956 11.6097V12.9181L15.2033 12.851C15.2369 12.7503 15.2369 11.6768 15.2033 11.5091L13.9956 11.6097Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.45493 14.0923L7.42139 15.1658H8.83036V14.0587L7.45493 14.0923Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.45493 10.3348L7.42139 11.4083L8.83036 11.2406V10.1335L7.45493 10.3348Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.45493 12.2135L7.42139 13.287L8.3607 13.2535V12.1129L7.45493 12.2135Z"
        fill="white"
      />
    </svg>
    <svg
      v-if="name === 'kcell'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="12"
        fill="#5A2884"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.42871 9.53343V14.7057H4.61693V13.0631C4.61693 12.9932 5.17609 12.3991 5.31588 12.3642L6.574 14.2514C6.99337 14.8105 7.55253 14.7057 8.32137 14.7057C8.21653 14.496 7.93695 14.1465 7.76221 13.9019L6.04978 11.5604C6.15462 11.4206 7.09821 10.5469 7.41274 10.1275C7.55253 9.98775 8.00685 9.60333 8.04179 9.42859C6.81863 9.42859 6.64389 9.42859 5.80515 10.3372L4.61693 11.5953C4.61693 10.5819 4.82661 9.70817 4.12766 9.49848C3.95292 9.46354 3.91798 9.49848 3.74324 9.46354C3.67334 9.46354 3.42871 9.35869 3.42871 9.53343Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.2349 12.6787C12.2349 13.2378 12.3397 13.7271 12.6892 14.1115L12.9338 14.3562C13.0037 14.426 13.0037 14.426 13.0736 14.461C13.8075 14.9503 15.1006 14.9153 15.6947 14.1465C15.9393 13.8319 15.9044 13.7271 16.0442 13.4825C15.9044 13.4825 15.3452 13.4825 15.2404 13.4825C15.1705 13.4825 15.1006 13.5524 15.0656 13.5873C14.9608 13.6921 15.1006 13.6223 14.786 13.8319C14.5065 14.0067 13.7027 14.0416 13.493 13.4825C13.4231 13.3077 13.4231 13.2029 13.4231 13.0281H16.149C16.149 12.5039 16.149 12.434 15.9743 11.9098C15.5549 10.6168 13.7027 10.1974 12.6542 11.5254C12.3747 11.8399 12.2349 12.3292 12.2349 12.6787ZM14.9608 12.3641H13.3182C13.3182 11.4555 14.4366 11.4555 14.7161 11.77C14.821 11.8749 14.9608 12.1894 14.9608 12.3641Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.07715 12.7835C8.07715 15.16 10.9429 15.2998 11.6768 13.9019C11.7816 13.6922 11.8165 13.4475 11.8864 13.2379C11.6768 13.2379 11.4671 13.2379 11.2224 13.2379C11.1176 13.2379 11.0477 13.2379 10.9429 13.2728C10.6982 13.4126 10.8031 13.5873 10.5235 13.832C10.3138 14.0067 9.89442 14.0417 9.61484 13.9019C9.05568 13.5524 9.05568 12.5389 9.26537 12.0846C9.40516 11.805 9.61484 11.6303 9.96432 11.5953C10.209 11.5604 10.4885 11.7002 10.6283 11.9099C10.6633 11.9797 10.7332 12.1545 10.8031 12.1894C10.9429 12.2943 11.502 12.2593 11.7117 12.2593C11.9563 12.2593 11.6418 11.4555 11.2923 11.176C9.96432 10.1974 8.07715 10.9663 8.07715 12.7835Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.6738 9.53395C16.6738 10.2329 16.6388 13.8325 16.7087 14.2169C16.8136 14.7062 17.3028 14.7062 17.7222 14.7062V10.1281C17.7222 9.499 17.3378 9.499 17.0233 9.46405C16.9184 9.46405 16.6738 9.35921 16.6738 9.53395Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.666 9.53395V13.9024C18.666 14.1121 18.7359 14.3917 18.8408 14.4965C19.0504 14.7062 19.4349 14.7062 19.7144 14.7062V10.1281C19.7144 9.499 19.33 9.499 19.0155 9.46405C18.9106 9.46405 18.666 9.35921 18.666 9.53395Z"
        fill="white"
      />
    </svg>
    <svg
      v-if="name==='activ'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="11.75"
        fill="white"
        stroke="#F2F2F2"
        stroke-width="0.5"
      />
      <path
        d="M6.47021 13.9583V14.2775C6.16784 14.0293 5.77654 13.8874 5.33187 13.8874C4.28247 13.8874 3.42871 14.7741 3.42871 15.9445C3.42871 16.4766 3.62436 16.9731 3.92674 17.3278C4.26468 17.7357 4.81606 18.0017 5.38523 18.0017C5.77654 18.0017 6.15005 17.8775 6.47021 17.6115V17.9307H7.46626V13.9583H6.47021ZM6.43464 16.512C6.23899 16.7958 5.88326 16.9908 5.49195 16.9908C4.905 16.9908 4.46033 16.5298 4.46033 15.9091C4.46033 15.3416 4.85164 14.8273 5.45638 14.8273C5.86547 14.8273 6.20342 15.0224 6.41685 15.3239V16.512H6.43464ZM11.824 17.0972C11.3615 17.7179 10.7923 17.9839 10.0631 17.9839C8.85361 17.9839 7.96428 17.0795 7.96428 15.9268C7.96428 14.7741 8.8714 13.8697 10.0631 13.8697C10.739 13.8697 11.3437 14.1889 11.6995 14.65L10.9702 15.3061C10.7568 15.0224 10.4544 14.8273 10.0809 14.8273C9.47614 14.8273 9.03148 15.3061 9.03148 15.9091C9.03148 16.5298 9.47614 16.9908 10.0987 16.9908C10.5255 16.9908 10.8635 16.7248 11.0236 16.4766L11.824 17.0972ZM14.9188 17.8953C14.7765 17.9485 14.4742 17.9839 14.2785 17.9839C13.656 17.9839 13.1935 17.7711 12.9267 17.4165C12.7311 17.1505 12.6422 16.7958 12.6422 16.246V14.8628H11.984V13.9761H12.6422V12.8588H13.6916V13.9583H14.9366V14.845H13.6916V16.3524C13.6916 16.6007 13.7271 16.7426 13.8161 16.849C13.9228 16.9731 14.0829 17.044 14.3497 17.044C14.5097 17.044 14.7054 17.0263 14.7765 17.0086L14.9188 17.8953ZM15.6303 13.9583H16.6797V17.8953H15.6303V13.9583ZM21.4287 13.9583L19.6501 17.8953H18.9208L17.1244 13.9583H18.2093L19.2765 16.3702L20.3437 13.9583H21.4287Z"
        fill="#9F248F"
      />
      <path
        d="M16.8386 6.11082C16.8386 6.14639 16.803 6.18197 16.7674 6.18197C16.7319 6.18197 16.6963 6.14639 16.6963 6.11082C16.6963 6.07525 16.7319 6.03967 16.7674 6.03967C16.803 6.03967 16.8386 6.07525 16.8386 6.11082Z"
        fill="#F4764A"
      />
      <path
        d="M16.6253 4.58124C16.5898 4.58124 16.5542 4.61681 16.5542 4.65238C16.5542 4.68796 16.5898 4.72353 16.6253 4.72353C16.6609 4.72353 16.6965 4.68796 16.6965 4.65238C16.6787 4.61681 16.6609 4.58124 16.6253 4.58124Z"
        fill="#F68943"
      />
      <path
        d="M10.987 3.63847C10.987 3.60289 10.9514 3.56732 10.9159 3.56732C10.8803 3.56732 10.8447 3.60289 10.8447 3.63847C10.8447 3.67404 10.8803 3.70961 10.9159 3.70961C10.9514 3.70961 10.987 3.67404 10.987 3.63847Z"
        fill="#D22587"
      />
      <path
        d="M14.224 4.10103C14.2596 4.10103 14.2951 4.06546 14.2951 4.02989C14.2951 3.99431 14.2596 3.95874 14.224 3.95874C14.1884 3.95874 14.1528 3.99431 14.1528 4.02989C14.1528 4.06546 14.1884 4.10103 14.224 4.10103Z"
        fill="#F68635"
      />
      <path
        d="M11.6633 4.08323C11.6633 4.04766 11.6277 4.01208 11.5921 4.01208C11.5566 4.01208 11.521 4.04766 11.521 4.08323C11.521 4.1188 11.5566 4.15438 11.5921 4.15438C11.6277 4.13659 11.6633 4.1188 11.6633 4.08323Z"
        fill="#DA2680"
      />
      <path
        d="M16.5365 5.15041C16.5721 5.15041 16.6076 5.11484 16.6076 5.07926C16.6076 5.04369 16.5721 5.00812 16.5365 5.00812C16.5009 5.00812 16.4653 5.04369 16.4653 5.07926C16.4653 5.11484 16.5009 5.15041 16.5365 5.15041Z"
        fill="#F58445"
      />
      <path
        d="M15.2915 5.63065C15.2915 5.96859 15.5761 6.25318 15.914 6.25318C16.252 6.25318 16.5366 5.96859 16.5366 5.63065C16.5366 5.2927 16.252 5.00812 15.914 5.00812C15.5761 5.00812 15.2915 5.2927 15.2915 5.63065Z"
        fill="#F58046"
      />
      <path
        d="M15.6113 4.70579C15.6113 4.84808 15.718 4.9548 15.8603 4.9548C16.0026 4.9548 16.1094 4.84808 16.1094 4.70579C16.1094 4.5635 16.0026 4.45678 15.8603 4.45678C15.7358 4.43899 15.6113 4.5635 15.6113 4.70579Z"
        fill="#F68D43"
      />
      <path
        d="M15.5583 4.97251C15.5583 4.93694 15.5227 4.90137 15.4872 4.90137C15.4516 4.90137 15.416 4.93694 15.416 4.97251C15.416 5.00809 15.4516 5.04366 15.4872 5.04366C15.5227 5.04366 15.5583 5.00809 15.5583 4.97251Z"
        fill="#F68D43"
      />
      <path
        d="M15.5049 4.20776C15.5049 4.2789 15.576 4.33226 15.6294 4.33226C15.7005 4.33226 15.7539 4.2789 15.7539 4.20776C15.7539 4.13661 15.7005 4.08325 15.6294 4.08325C15.5582 4.08325 15.5049 4.13661 15.5049 4.20776Z"
        fill="#F79442"
      />
      <path
        d="M15.5047 3.85195C15.5403 3.85195 15.5759 3.81637 15.5759 3.7808C15.5759 3.74523 15.5403 3.70966 15.5047 3.70966C15.4692 3.70966 15.4336 3.74523 15.4336 3.7808C15.4336 3.83416 15.4692 3.85195 15.5047 3.85195Z"
        fill="#F89B41"
      />
      <path
        d="M15.2915 4.68788C15.2915 4.75902 15.3449 4.81238 15.416 4.81238C15.4872 4.81238 15.5405 4.75902 15.5405 4.68788C15.5405 4.61673 15.4872 4.56337 15.416 4.56337C15.3449 4.54559 15.2915 4.61673 15.2915 4.68788Z"
        fill="#F79243"
      />
      <path
        d="M14.2954 4.31452C14.2954 4.5991 14.5266 4.83033 14.8112 4.83033C15.0958 4.83033 15.327 4.5991 15.327 4.31452C15.327 4.02993 15.0958 3.79871 14.8112 3.79871C14.5266 3.79871 14.2954 4.02993 14.2954 4.31452Z"
        fill="#F8963E"
      />
      <path
        d="M14.6688 3.5674C14.7044 3.5674 14.74 3.53183 14.74 3.49626C14.74 3.46068 14.7044 3.42511 14.6688 3.42511C14.6332 3.42511 14.5977 3.46068 14.5977 3.49626C14.6154 3.54962 14.6332 3.5674 14.6688 3.5674Z"
        fill="#F68936"
      />
      <path
        d="M14.3846 3.86968C14.4557 3.86968 14.5091 3.81632 14.5091 3.74517C14.5091 3.67403 14.4557 3.62067 14.3846 3.62067C14.3134 3.62067 14.2601 3.67403 14.2601 3.74517C14.2423 3.81632 14.3134 3.86968 14.3846 3.86968Z"
        fill="#F68635"
      />
      <path
        d="M13.6196 3.54966C13.6196 3.69195 13.7263 3.79867 13.8686 3.79867C14.0109 3.79867 14.1177 3.69195 14.1177 3.54966C14.1177 3.40737 14.0109 3.30065 13.8686 3.30065C13.7263 3.28286 13.6196 3.40737 13.6196 3.54966Z"
        fill="#F47430"
      />
      <path
        d="M13.6551 2.90926C13.6907 2.90926 13.7263 2.87369 13.7263 2.83811C13.7263 2.80254 13.6907 2.76697 13.6551 2.76697C13.6196 2.76697 13.584 2.80254 13.584 2.83811C13.584 2.87369 13.6196 2.90926 13.6551 2.90926Z"
        fill="#F26634"
      />
      <path
        d="M13.6371 4.01217C13.6726 4.01217 13.7082 3.97659 13.7082 3.94102C13.7082 3.90545 13.6726 3.86987 13.6371 3.86987C13.6015 3.86987 13.5659 3.90545 13.5659 3.94102C13.5659 3.97659 13.6015 4.01217 13.6371 4.01217Z"
        fill="#F37230"
      />
      <path
        d="M15.6825 7.64056C15.6469 7.64056 15.6113 7.67614 15.6113 7.71171C15.6113 7.74728 15.6469 7.78286 15.6825 7.78286C15.718 7.78286 15.7536 7.74728 15.7536 7.71171C15.7536 7.67614 15.718 7.64056 15.6825 7.64056Z"
        fill="#F15C50"
      />
      <path
        d="M12.2144 3.97638C12.2144 4.33211 12.4989 4.61669 12.8547 4.61669C13.2104 4.61669 13.495 4.33211 13.495 3.97638C13.495 3.62064 13.2104 3.33606 12.8547 3.33606C12.4989 3.33606 12.2144 3.62064 12.2144 3.97638Z"
        fill="#F15943"
      />
      <path
        d="M13.2461 3.31841C13.3172 3.31841 13.3706 3.26505 13.3706 3.1939C13.3706 3.12276 13.3172 3.0694 13.2461 3.0694C13.1749 3.0694 13.1216 3.12276 13.1216 3.1939C13.1216 3.26505 13.1749 3.31841 13.2461 3.31841Z"
        fill="#F1603C"
      />
      <path
        d="M12.9793 2.90926C13.0149 2.90926 13.0505 2.87369 13.0505 2.83811C13.0505 2.80254 13.0149 2.76697 12.9793 2.76697C12.9438 2.76697 12.9082 2.80254 12.9082 2.83811C12.926 2.87369 12.9438 2.90926 12.9793 2.90926Z"
        fill="#F15645"
      />
      <path
        d="M12.3568 3.47835C12.3924 3.47835 12.4279 3.44278 12.4279 3.40721C12.4279 3.37163 12.3924 3.33606 12.3568 3.33606C12.3212 3.33606 12.2856 3.37163 12.2856 3.40721C12.2856 3.46057 12.3212 3.47835 12.3568 3.47835Z"
        fill="#EE445A"
      />
      <path
        d="M12.1966 4.4211C12.2322 4.4211 12.2678 4.38553 12.2678 4.34995C12.2678 4.31438 12.2322 4.27881 12.1966 4.27881C12.1611 4.27881 12.1255 4.31438 12.1255 4.34995C12.1255 4.40331 12.1611 4.4211 12.1966 4.4211Z"
        fill="#EA3E60"
      />
      <path
        d="M11.9834 3.79862C12.1257 3.79862 12.2324 3.6919 12.2324 3.54961C12.2324 3.40732 12.1257 3.3006 11.9834 3.3006C11.8411 3.3006 11.7344 3.40732 11.7344 3.54961C11.7344 3.67412 11.8411 3.79862 11.9834 3.79862Z"
        fill="#E4366A"
      />
      <path
        d="M11.6097 3.5674C11.6453 3.5674 11.6809 3.53183 11.6809 3.49626C11.6809 3.46068 11.6453 3.42511 11.6097 3.42511C11.5741 3.42511 11.5386 3.46068 11.5386 3.49626C11.5386 3.53183 11.5741 3.5674 11.6097 3.5674Z"
        fill="#DD2878"
      />
      <path
        d="M11.5742 3.86968C11.6454 3.86968 11.6987 3.81632 11.6987 3.74517C11.6987 3.67403 11.6454 3.62067 11.5742 3.62067C11.5031 3.62067 11.4497 3.67403 11.4497 3.74517C11.4497 3.81632 11.5031 3.86968 11.5742 3.86968Z"
        fill="#DB267F"
      />
      <path
        d="M12.2854 4.75901C12.3565 4.75901 12.4277 4.70565 12.4277 4.61672C12.4277 4.54557 12.3743 4.47443 12.2854 4.47443C12.2142 4.47443 12.1431 4.52779 12.1431 4.61672C12.1609 4.68786 12.2142 4.75901 12.2854 4.75901Z"
        fill="#EF4558"
      />
      <path
        d="M12.143 3.99428C12.143 3.92314 12.0896 3.85199 12.0007 3.85199C11.9295 3.85199 11.8584 3.90535 11.8584 3.99428C11.8584 4.06543 11.9118 4.13657 12.0007 4.13657C12.0718 4.13657 12.143 4.06543 12.143 3.99428Z"
        fill="#E53669"
      />
      <path
        d="M12.4458 4.77695C12.4458 4.83031 12.4992 4.88367 12.5525 4.88367C12.6059 4.88367 12.6592 4.83031 12.6592 4.77695C12.6592 4.72359 12.6059 4.67023 12.5525 4.67023C12.4814 4.67023 12.4458 4.72359 12.4458 4.77695Z"
        fill="#F0504B"
      />
      <path
        d="M11.1828 3.49625C11.3251 3.49625 11.4319 3.38953 11.4319 3.24724C11.4319 3.10495 11.3251 2.99823 11.1828 2.99823C11.0405 2.99823 10.9338 3.10495 10.9338 3.24724C10.916 3.38953 11.0405 3.49625 11.1828 3.49625Z"
        fill="#D72683"
      />
      <path
        d="M10.827 2.9983C10.8981 2.9983 10.9515 2.94495 10.9515 2.85601C10.9515 2.78487 10.8981 2.73151 10.827 2.73151C10.7558 2.73151 10.7025 2.78487 10.7025 2.85601C10.6847 2.94495 10.7558 2.9983 10.827 2.9983Z"
        fill="#D32586"
      />
      <path
        d="M10.6136 2.7137C10.6492 2.7137 10.6848 2.67813 10.6848 2.64256C10.6848 2.60698 10.6492 2.57141 10.6136 2.57141C10.5781 2.57141 10.5425 2.60698 10.5425 2.64256C10.5425 2.69592 10.5781 2.7137 10.6136 2.7137Z"
        fill="#D22587"
      />
      <path
        d="M10.4177 3.97646C10.6311 3.97646 10.809 3.79859 10.809 3.58515C10.809 3.37171 10.6311 3.19385 10.4177 3.19385C10.2042 3.19385 10.0264 3.37171 10.0264 3.58515C10.0442 3.79859 10.2042 3.97646 10.4177 3.97646Z"
        fill="#CA2A90"
      />
      <path
        d="M10.1509 3.12276C10.1865 3.12276 10.2043 3.08719 10.2043 3.05162C10.2043 3.01604 10.1687 2.98047 10.1332 2.98047C10.0976 2.98047 10.062 3.01604 10.062 3.05162C10.0798 3.08719 10.1154 3.12276 10.1509 3.12276Z"
        fill="#CA2A90"
      />
      <path
        d="M9.91978 3.63857C9.95535 3.63857 9.99092 3.603 9.99092 3.56742C9.99092 3.53185 9.95535 3.49628 9.91978 3.49628C9.88421 3.49628 9.84863 3.53185 9.84863 3.56742C9.84863 3.603 9.88421 3.63857 9.91978 3.63857Z"
        fill="#C32F92"
      />
      <path
        d="M8.92383 4.22555C8.92383 4.58129 9.20841 4.84808 9.54636 4.84808C9.90209 4.84808 10.1689 4.5635 10.1689 4.22555C10.1689 3.86982 9.8843 3.60302 9.54636 3.60302C9.20841 3.58524 8.92383 3.86982 8.92383 4.22555Z"
        fill="#B43894"
      />
      <path
        d="M9.01269 3.65624C9.08384 3.65624 9.1372 3.60288 9.1372 3.53173C9.1372 3.46059 9.08384 3.40723 9.01269 3.40723C8.94154 3.40723 8.88818 3.46059 8.88818 3.53173C8.88818 3.60288 8.94154 3.65624 9.01269 3.65624Z"
        fill="#B43894"
      />
      <path
        d="M8.81689 4.70586C8.88803 4.70586 8.94139 4.6525 8.94139 4.58135C8.94139 4.51021 8.88803 4.45685 8.81689 4.45685C8.74574 4.45685 8.69238 4.51021 8.69238 4.58135C8.69238 4.6525 8.74574 4.70586 8.81689 4.70586Z"
        fill="#9E3D96"
      />
      <path
        d="M8.14111 4.74132C8.14111 4.88361 8.24783 4.99033 8.39012 4.99033C8.53242 4.99033 8.63914 4.88361 8.63914 4.74132C8.63914 4.59903 8.53242 4.49231 8.39012 4.49231C8.26562 4.49231 8.14111 4.59903 8.14111 4.74132Z"
        fill="#943C96"
      />
      <path
        d="M12.4097 10.5932C12.303 10.5932 12.1963 10.6821 12.1963 10.8066C12.1963 10.9134 12.2852 11.0201 12.4097 11.0201C12.5164 11.0201 12.6232 10.9311 12.6232 10.8066C12.6232 10.6821 12.5342 10.5932 12.4097 10.5932Z"
        fill="#8C377E"
      />
      <path
        d="M8.2303 4.3145C8.30144 4.3145 8.3548 4.26114 8.3548 4.19C8.3548 4.11885 8.30144 4.06549 8.2303 4.06549C8.15915 4.06549 8.10579 4.11885 8.10579 4.19C8.08801 4.24336 8.15915 4.3145 8.2303 4.3145Z"
        fill="#9C3D97"
      />
      <path
        d="M8.26548 3.86983C8.30106 3.86983 8.33663 3.83426 8.33663 3.79869C8.33663 3.76311 8.30106 3.72754 8.26548 3.72754C8.22991 3.72754 8.19434 3.76311 8.19434 3.79869C8.19434 3.83426 8.22991 3.86983 8.26548 3.86983Z"
        fill="#A53B96"
      />
      <path
        d="M7.99888 5.2394C8.03445 5.2394 8.07003 5.20383 8.07003 5.16825C8.07003 5.13268 8.03445 5.09711 7.99888 5.09711C7.96331 5.09711 7.92773 5.13268 7.92773 5.16825C7.92773 5.20383 7.96331 5.2394 7.99888 5.2394Z"
        fill="#873E97"
      />
      <path
        d="M7.96337 6.27099C7.96337 6.19984 7.91001 6.14648 7.83886 6.14648C7.76772 6.14648 7.71436 6.19984 7.71436 6.27099C7.71436 6.34214 7.76772 6.3955 7.83886 6.3955C7.91001 6.3955 7.96337 6.34214 7.96337 6.27099Z"
        fill="#6D4099"
      />
      <path
        d="M7.91015 8.01404C7.839 8.01404 7.78564 8.0674 7.78564 8.13854C7.78564 8.20969 7.839 8.26305 7.91015 8.26305C7.9813 8.26305 8.03466 8.20969 8.03466 8.13854C8.03466 8.08518 7.9813 8.01404 7.91015 8.01404Z"
        fill="#404B9F"
      />
      <path
        d="M8.46141 8.19183C8.31912 8.19183 8.2124 8.29855 8.2124 8.44085C8.2124 8.58314 8.31912 8.68986 8.46141 8.68986C8.60371 8.68986 8.71043 8.58314 8.71043 8.44085C8.71043 8.29855 8.60371 8.19183 8.46141 8.19183Z"
        fill="#354DA1"
      />
      <path
        d="M8.38999 9.09906C8.35442 9.09906 8.31885 9.13463 8.31885 9.17021C8.31885 9.20578 8.35442 9.24135 8.38999 9.24135C8.42557 9.24135 8.46114 9.20578 8.46114 9.17021C8.46114 9.13463 8.42557 9.09906 8.38999 9.09906Z"
        fill="#2551A3"
      />
      <path
        d="M9.01268 8.51208C8.87039 8.51208 8.76367 8.6188 8.76367 8.7611C8.76367 8.90339 8.87039 9.01011 9.01268 9.01011C9.15498 9.01011 9.2617 8.8856 9.2617 8.7611C9.2617 8.6188 9.15498 8.51208 9.01268 8.51208Z"
        fill="#2750A3"
      />
      <path
        d="M9.08398 9.13452C9.01283 9.13452 8.95947 9.18788 8.95947 9.25903C8.95947 9.33017 9.01283 9.38353 9.08398 9.38353C9.15512 9.38353 9.20848 9.33017 9.20848 9.25903C9.20848 9.20567 9.15512 9.13452 9.08398 9.13452Z"
        fill="#1A53A5"
      />
      <path
        d="M9.10156 8.20967C9.10156 8.40533 9.26164 8.56541 9.45729 8.56541C9.65295 8.56541 9.81302 8.40533 9.81302 8.20967C9.81302 8.01402 9.65295 7.85394 9.45729 7.85394C9.26164 7.85394 9.10156 8.01402 9.10156 8.20967Z"
        fill="#324EA1"
      />
      <path
        d="M9.56417 4.99034C9.56417 4.95476 9.52859 4.91919 9.49302 4.91919C9.45745 4.91919 9.42188 4.95476 9.42188 4.99034C9.42188 5.02591 9.45745 5.06148 9.49302 5.06148C9.54638 5.04369 9.56417 5.02591 9.56417 4.99034Z"
        fill="#A33C96"
      />
      <path
        d="M11.2896 4.51011C11.2896 4.54568 11.3251 4.58126 11.3607 4.58126C11.3963 4.58126 11.4318 4.54568 11.4318 4.51011C11.4318 4.47454 11.3963 4.43896 11.3607 4.43896C11.3251 4.45675 11.2896 4.47454 11.2896 4.51011Z"
        fill="#D42486"
      />
      <path
        d="M11.7873 3.94102C11.7873 3.90545 11.7517 3.86987 11.7162 3.86987C11.6806 3.86987 11.645 3.90545 11.645 3.94102C11.645 3.97659 11.6806 4.01217 11.7162 4.01217C11.7695 4.01217 11.7873 3.97659 11.7873 3.94102Z"
        fill="#DD2A77"
      />
      <path
        d="M11.8584 4.86588C11.8584 4.90146 11.894 4.93703 11.9295 4.93703C11.9651 4.93703 12.0007 4.90146 12.0007 4.86588C12.0007 4.83031 11.9651 4.79474 11.9295 4.79474C11.894 4.79474 11.8584 4.83031 11.8584 4.86588Z"
        fill="#DF2D72"
      />
      <path
        d="M9.42194 7.78285C9.4753 7.78285 9.51087 7.74727 9.51087 7.69391C9.51087 7.64055 9.4753 7.60498 9.42194 7.60498C9.36858 7.60498 9.33301 7.64055 9.33301 7.69391C9.33301 7.74727 9.38637 7.78285 9.42194 7.78285Z"
        fill="#44499E"
      />
      <path
        d="M9.38612 5.11488C9.38612 4.90144 9.20826 4.72357 8.99482 4.72357C8.78138 4.72357 8.60352 4.90144 8.60352 5.11488C8.60352 5.32831 8.78138 5.50618 8.99482 5.50618C9.20826 5.50618 9.38612 5.32831 9.38612 5.11488Z"
        fill="#943C96"
      />
      <path
        d="M7.85645 6.69792C7.85645 6.84021 7.96316 6.94693 8.10546 6.94693C8.24775 6.94693 8.35447 6.84021 8.35447 6.69792C8.35447 6.55562 8.24775 6.4489 8.10546 6.4489C7.98095 6.43112 7.85645 6.55562 7.85645 6.69792Z"
        fill="#63429A"
      />
      <path
        d="M8.49707 6.66229C8.49707 6.73343 8.55043 6.78679 8.62158 6.78679C8.69272 6.78679 8.74608 6.73343 8.74608 6.66229C8.74608 6.59114 8.69272 6.53778 8.62158 6.53778C8.56822 6.53778 8.49707 6.59114 8.49707 6.66229Z"
        fill="#664199"
      />
      <path
        d="M9.15499 5.63066C9.15499 5.59508 9.11941 5.55951 9.08384 5.55951C9.04827 5.55951 9.0127 5.59508 9.0127 5.63066C9.0127 5.66623 9.04827 5.7018 9.08384 5.7018C9.1372 5.7018 9.15499 5.66623 9.15499 5.63066Z"
        fill="#873E97"
      />
      <path
        d="M8.92382 6.71563C8.99497 6.71563 9.04833 6.66227 9.04833 6.59112C9.04833 6.51997 8.99497 6.46661 8.92382 6.46661C8.85268 6.46661 8.79932 6.51997 8.79932 6.59112C8.79932 6.66227 8.85268 6.71563 8.92382 6.71563Z"
        fill="#6A4099"
      />
      <path
        d="M9.0482 6.87575C9.08377 6.87575 9.11934 6.84018 9.11934 6.80461C9.11934 6.76903 9.08377 6.73346 9.0482 6.73346C9.01262 6.73346 8.97705 6.76903 8.97705 6.80461C8.97705 6.84018 9.01262 6.87575 9.0482 6.87575Z"
        fill="#64429A"
      />
      <path
        d="M8.76367 8.2809C8.76367 8.35204 8.81703 8.4054 8.88818 8.4054C8.95932 8.4054 9.01268 8.35204 9.01268 8.2809C9.01268 8.20975 8.95932 8.15639 8.88818 8.15639C8.83482 8.1386 8.76367 8.20975 8.76367 8.2809Z"
        fill="#364CA0"
      />
      <path
        d="M8.67498 8.10296C9.03072 8.10296 9.3153 7.81838 9.3153 7.46264C9.3153 7.10691 9.03072 6.82233 8.67498 6.82233C8.31925 6.82233 8.03467 7.10691 8.03467 7.46264C8.03467 7.81838 8.31925 8.10296 8.67498 8.10296Z"
        fill="#50469C"
      />
      <path
        d="M8.56786 5.25707C8.56786 5.18593 8.5145 5.13257 8.44335 5.13257C8.37221 5.13257 8.31885 5.18593 8.31885 5.25707C8.31885 5.32822 8.37221 5.38158 8.44335 5.38158C8.49671 5.38158 8.56786 5.32822 8.56786 5.25707Z"
        fill="#893E97"
      />
      <path
        d="M9.06629 5.98639C9.06629 5.70181 8.83506 5.47058 8.55048 5.47058C8.26589 5.47058 8.03467 5.70181 8.03467 5.98639C8.03467 6.27098 8.26589 6.5022 8.55048 6.5022C8.83506 6.5022 9.06629 6.27098 9.06629 5.98639Z"
        fill="#783F98"
      />
      <path
        d="M10.5424 9.17008C10.5424 8.83213 10.2578 8.54755 9.91989 8.54755C9.56416 8.54755 9.29736 8.83213 9.29736 9.17008C9.29736 9.50802 9.58195 9.79261 9.91989 9.79261C10.2578 9.79261 10.5424 9.50802 10.5424 9.17008Z"
        fill="#2351A3"
      />
      <path
        d="M10.0088 10.0417C10.0088 9.97054 9.95542 9.91718 9.88427 9.91718C9.81313 9.91718 9.75977 9.97054 9.75977 10.0417C9.75977 10.1128 9.81313 10.1662 9.88427 10.1662C9.95542 10.1662 10.0088 10.1128 10.0088 10.0417Z"
        fill="#344CA0"
      />
      <path
        d="M10.0799 10.433C10.0444 10.433 10.0088 10.4686 10.0088 10.5041C10.0088 10.5397 10.0444 10.5753 10.0799 10.5753C10.1155 10.5753 10.1511 10.5397 10.1511 10.5041C10.1511 10.4508 10.1155 10.433 10.0799 10.433Z"
        fill="#40499E"
      />
      <path
        d="M10.311 9.77496C10.2399 9.77496 10.1865 9.82832 10.1865 9.89947C10.1865 9.97061 10.2399 10.024 10.311 10.024C10.3822 10.024 10.4355 9.97061 10.4355 9.89947C10.4355 9.82832 10.3822 9.77496 10.311 9.77496Z"
        fill="#3C4A9F"
      />
      <path
        d="M11.2538 9.70387C11.2538 9.49043 11.0759 9.31256 10.8625 9.31256C10.6491 9.31256 10.4712 9.49043 10.4712 9.70387C10.4712 9.9173 10.6491 10.0952 10.8625 10.0952C11.0937 10.0952 11.2538 9.9173 11.2538 9.70387Z"
        fill="#4B469D"
      />
      <path
        d="M10.8983 10.7177C10.8627 10.7177 10.8271 10.7532 10.8271 10.7888C10.8271 10.8244 10.8627 10.8599 10.8983 10.8599C10.9339 10.8599 10.9694 10.8244 10.9694 10.7888C10.9694 10.7354 10.9339 10.7177 10.8983 10.7177Z"
        fill="#5E4197"
      />
      <path
        d="M11.0762 10.0951C11.005 10.0951 10.9517 10.1485 10.9517 10.2196C10.9517 10.2907 11.005 10.3441 11.0762 10.3441C11.1473 10.3441 11.2007 10.2907 11.2007 10.2196C11.2185 10.1662 11.1473 10.0951 11.0762 10.0951Z"
        fill="#5C429A"
      />
      <path
        d="M11.3784 10.5576C11.3073 10.5576 11.2539 10.6109 11.2539 10.6821C11.2539 10.7532 11.3073 10.8066 11.3784 10.8066C11.4496 10.8066 11.5029 10.7532 11.5029 10.6821C11.5029 10.6109 11.4496 10.5576 11.3784 10.5576Z"
        fill="#6C3E8F"
      />
      <path
        d="M11.0939 3.72754C10.8805 3.72754 10.7026 3.9054 10.7026 4.11884C10.7026 4.33228 10.8805 4.51015 11.0939 4.51015C11.3074 4.51015 11.4852 4.33228 11.4852 4.11884C11.4852 3.88762 11.3074 3.72754 11.0939 3.72754Z"
        fill="#D22587"
      />
      <path
        d="M11.6628 9.79272C11.4494 9.79272 11.2715 9.97059 11.2715 10.184C11.2715 10.3975 11.4494 10.5753 11.6628 10.5753C11.8762 10.5753 12.0541 10.3975 12.0541 10.184C12.0541 9.97059 11.8762 9.79272 11.6628 9.79272Z"
        fill="#723C8D"
      />
      <path
        d="M11.9652 10.6821C11.9296 10.6821 11.894 10.7176 11.894 10.7532C11.894 10.7888 11.9296 10.8244 11.9652 10.8244C12.0008 10.8244 12.0363 10.7888 12.0363 10.7532C12.0185 10.7176 12.0008 10.6821 11.9652 10.6821Z"
        fill="#7E3985"
      />
      <path
        d="M12.1429 10.5576C12.1074 10.5576 12.0718 10.5931 12.0718 10.6287C12.0718 10.6643 12.1074 10.6998 12.1429 10.6998C12.1785 10.6998 12.2141 10.6643 12.2141 10.6287C12.2141 10.5931 12.1785 10.5576 12.1429 10.5576Z"
        fill="#843983"
      />
      <path
        d="M12.2143 10.2552C12.1432 10.2552 12.0898 10.3085 12.0898 10.3797C12.0898 10.4508 12.1432 10.5042 12.2143 10.5042C12.2855 10.5042 12.3389 10.4508 12.3389 10.3797C12.3566 10.3085 12.2855 10.2552 12.2143 10.2552Z"
        fill="#843882"
      />
      <path
        d="M12.25 9.935C12.1788 9.935 12.1255 9.98836 12.1255 10.0595C12.1255 10.1306 12.1788 10.184 12.25 10.184C12.3211 10.184 12.3745 10.1306 12.3745 10.0595C12.3745 9.98836 12.3211 9.935 12.25 9.935Z"
        fill="#873881"
      />
      <path
        d="M12.4279 5.00818C12.4279 4.90146 12.3389 4.79474 12.2144 4.79474C12.1077 4.79474 12.001 4.88367 12.001 5.00818C12.001 5.1149 12.0899 5.22162 12.2144 5.22162C12.3389 5.22162 12.4279 5.13268 12.4279 5.00818Z"
        fill="#EE435A"
      />
      <path
        d="M12.0896 4.45679C12.0896 4.29671 11.9473 4.15442 11.7872 4.15442C11.6272 4.15442 11.4849 4.29671 11.4849 4.45679C11.4849 4.61687 11.6272 4.75916 11.7872 4.75916C11.9473 4.75916 12.0896 4.63466 12.0896 4.45679Z"
        fill="#DD2977"
      />
      <path
        d="M10.4535 4.10101C10.3467 4.10101 10.2578 4.18995 10.2578 4.29667C10.2578 4.40338 10.3467 4.49232 10.4535 4.49232C10.5602 4.49232 10.6491 4.40338 10.6491 4.29667C10.6491 4.18995 10.5602 4.10101 10.4535 4.10101Z"
        fill="#C32F92"
      />
      <path
        d="M13.0684 9.61485C13.0684 9.65042 13.1039 9.686 13.1395 9.686C13.1751 9.686 13.2107 9.65042 13.2107 9.61485C13.2107 9.57927 13.1751 9.5437 13.1395 9.5437C13.1039 9.5437 13.0684 9.57927 13.0684 9.61485Z"
        fill="#B0326E"
      />
      <path
        d="M12.9616 9.72156C12.677 9.72156 12.4458 9.95278 12.4458 10.2374C12.4458 10.522 12.677 10.7532 12.9616 10.7532C13.2462 10.7532 13.4774 10.522 13.4774 10.2374C13.4774 9.95278 13.2462 9.72156 12.9616 9.72156Z"
        fill="#A03474"
      />
      <path
        d="M13.6728 10.0773C13.6017 10.0773 13.5483 10.1307 13.5483 10.2018C13.5483 10.273 13.6017 10.3263 13.6728 10.3263C13.744 10.3263 13.7974 10.273 13.7974 10.2018C13.7974 10.1307 13.744 10.0773 13.6728 10.0773Z"
        fill="#BE3069"
      />
      <path
        d="M14.1177 10.1128C13.9754 10.1128 13.8687 10.2195 13.8687 10.3618C13.8687 10.5041 13.9754 10.6108 14.1177 10.6108C14.26 10.6108 14.3667 10.5041 14.3667 10.3618C14.3845 10.2373 14.26 10.1128 14.1177 10.1128Z"
        fill="#C93166"
      />
      <path
        d="M13.9574 10.8243C13.9218 10.8243 13.8862 10.8599 13.8862 10.8954C13.8862 10.931 13.9218 10.9666 13.9574 10.9666C13.9929 10.9666 14.0285 10.931 14.0285 10.8954C14.0285 10.8599 13.9929 10.8243 13.9574 10.8243Z"
        fill="#BC316A"
      />
      <path
        d="M12.7123 11.0022C12.6767 11.0022 12.6411 11.0378 12.6411 11.0733C12.6411 11.1089 12.6767 11.1445 12.7123 11.1445C12.7478 11.1445 12.7834 11.1089 12.7834 11.0733C12.7834 11.0378 12.7478 11.0022 12.7123 11.0022Z"
        fill="#94357B"
      />
      <path
        d="M14.2773 9.56146C14.2062 9.56146 14.1528 9.61482 14.1528 9.68597C14.1528 9.75712 14.2062 9.81047 14.2773 9.81047C14.3485 9.81047 14.4018 9.75712 14.4018 9.68597C14.4196 9.61482 14.3485 9.56146 14.2773 9.56146Z"
        fill="#DF315F"
      />
      <path
        d="M14.0819 10.0061C14.1175 10.0061 14.153 9.97055 14.153 9.93498C14.153 9.8994 14.1175 9.86383 14.0819 9.86383C14.0463 9.86383 14.0107 9.8994 14.0107 9.93498C14.0285 9.97055 14.0463 10.0061 14.0819 10.0061Z"
        fill="#D13063"
      />
      <path
        d="M13.4238 4.42118C13.4238 4.45676 13.4594 4.49233 13.495 4.49233C13.5305 4.49233 13.5661 4.45676 13.5661 4.42118C13.5661 4.38561 13.5305 4.35004 13.495 4.35004C13.4594 4.35004 13.4238 4.38561 13.4238 4.42118Z"
        fill="#F4752F"
      />
      <path
        d="M13.8508 9.09904C13.8508 9.06347 13.8152 9.02789 13.7796 9.02789C13.7441 9.02789 13.7085 9.06347 13.7085 9.09904C13.7085 9.13461 13.7441 9.17019 13.7796 9.17019C13.8152 9.17019 13.8508 9.13461 13.8508 9.09904Z"
        fill="#DD3160"
      />
      <path
        d="M13.6726 9.22357C13.4591 9.22357 13.2812 9.40144 13.2812 9.61488C13.2812 9.82832 13.4591 10.0062 13.6726 10.0062C13.886 10.0062 14.0639 9.82832 14.0639 9.61488C14.0639 9.40144 13.886 9.22357 13.6726 9.22357Z"
        fill="#C83166"
      />
      <path
        d="M14.2064 4.58126C14.242 4.58126 14.2775 4.54568 14.2775 4.51011C14.2775 4.47454 14.242 4.43896 14.2064 4.43896C14.1708 4.43896 14.1353 4.47454 14.1353 4.51011C14.1353 4.54568 14.1708 4.58126 14.2064 4.58126Z"
        fill="#F7913B"
      />
      <path
        d="M14.3135 8.52986C14.3135 8.601 14.3668 8.65436 14.438 8.65436C14.5091 8.65436 14.5625 8.601 14.5625 8.52986C14.5625 8.45871 14.5091 8.40535 14.438 8.40535C14.3846 8.38757 14.3135 8.45871 14.3135 8.52986Z"
        fill="#EF4157"
      />
      <path
        d="M14.2951 8.67218C14.0817 8.67218 13.9038 8.85005 13.9038 9.06348C13.9038 9.27692 14.0817 9.45479 14.2951 9.45479C14.5086 9.45479 14.6864 9.27692 14.6864 9.06348C14.6864 8.85005 14.5086 8.67218 14.2951 8.67218Z"
        fill="#EE355B"
      />
      <path
        d="M14.9004 9.01019C14.8292 9.01019 14.7759 9.06355 14.7759 9.1347C14.7759 9.20585 14.8292 9.25921 14.9004 9.25921C14.9715 9.25921 15.0249 9.20585 15.0249 9.1347C15.0249 9.06355 14.9715 9.01019 14.9004 9.01019Z"
        fill="#EF3D59"
      />
      <path
        d="M15.2202 9.7395C15.1491 9.7395 15.0957 9.79286 15.0957 9.86401C15.0957 9.93515 15.1491 9.98851 15.2202 9.98851C15.2914 9.98851 15.3447 9.93515 15.3447 9.86401C15.3447 9.79286 15.2914 9.7395 15.2202 9.7395Z"
        fill="#EE375A"
      />
      <path
        d="M15.3451 9.41919C15.3095 9.41919 15.2739 9.45476 15.2739 9.49033C15.2739 9.52591 15.3095 9.56148 15.3451 9.56148C15.3806 9.56148 15.4162 9.52591 15.4162 9.49033C15.4162 9.45476 15.3806 9.41919 15.3451 9.41919Z"
        fill="#EF3C58"
      />
      <path
        d="M10.7206 9.25911C10.7561 9.25911 10.7917 9.22354 10.7917 9.18797C10.7917 9.15239 10.7561 9.11682 10.7206 9.11682C10.685 9.11682 10.6494 9.15239 10.6494 9.18797C10.6494 9.22354 10.685 9.25911 10.7206 9.25911Z"
        fill="#384CA0"
      />
      <path
        d="M15.256 7.69385C14.9003 7.69385 14.6157 7.97843 14.6157 8.33416C14.6157 8.6899 14.9003 8.97448 15.256 8.97448C15.6118 8.97448 15.8964 8.6899 15.8964 8.33416C15.8964 7.97843 15.6118 7.69385 15.256 7.69385Z"
        fill="#F04C53"
      />
      <path
        d="M15.9316 7.72949C15.8605 7.72949 15.8071 7.78285 15.8071 7.854C15.8071 7.92514 15.8605 7.9785 15.9316 7.9785C16.0028 7.9785 16.0561 7.92514 16.0561 7.854C16.0739 7.78285 16.0028 7.72949 15.9316 7.72949Z"
        fill="#F15A50"
      />
      <path
        d="M15.5583 6.27091C15.5583 6.23534 15.5227 6.19977 15.4872 6.19977C15.4516 6.19977 15.416 6.23534 15.416 6.27091C15.416 6.30649 15.4516 6.34206 15.4872 6.34206C15.5227 6.35985 15.5583 6.32427 15.5583 6.27091Z"
        fill="#F47848"
      />
      <path
        d="M15.3624 7.51605C15.4691 7.51605 15.5758 7.42712 15.5758 7.30261C15.5758 7.19589 15.4869 7.08917 15.3624 7.08917C15.2556 7.08917 15.1489 7.17811 15.1489 7.30261C15.1489 7.42712 15.2379 7.51605 15.3624 7.51605Z"
        fill="#F1634D"
      />
      <path
        d="M15.2201 5.31055C15.1845 5.31055 15.1489 5.34612 15.1489 5.38169C15.1489 5.41727 15.1845 5.45284 15.2201 5.45284C15.2556 5.45284 15.2912 5.41727 15.2912 5.38169C15.2734 5.32833 15.2556 5.31055 15.2201 5.31055Z"
        fill="#F68A42"
      />
      <path
        d="M15.0068 7.56938C15.0068 7.60495 15.0424 7.64052 15.078 7.64052C15.1136 7.64052 15.1491 7.60495 15.1491 7.56938C15.1491 7.5338 15.1136 7.49823 15.078 7.49823C15.0246 7.49823 15.0068 7.5338 15.0068 7.56938Z"
        fill="#F15D4F"
      />
      <path
        d="M16.1273 6.71571C16.1273 6.50227 15.9495 6.3244 15.736 6.3244C15.5226 6.3244 15.3447 6.50227 15.3447 6.71571C15.3447 6.92914 15.5226 7.10701 15.736 7.10701C15.9495 7.10701 16.1273 6.92914 16.1273 6.71571Z"
        fill="#F36E4B"
      />
      <path
        d="M16.0386 7.14252C15.8963 7.14252 15.7896 7.24924 15.7896 7.39153C15.7896 7.53382 15.8963 7.64054 16.0386 7.64054C16.1809 7.64054 16.2876 7.53382 16.2876 7.39153C16.2876 7.24924 16.1809 7.14252 16.0386 7.14252Z"
        fill="#F1614E"
      />
      <path
        d="M16.3589 7.65833C16.2877 7.65833 16.2344 7.71168 16.2344 7.80062C16.2344 7.87176 16.2877 7.92512 16.3767 7.92512C16.4478 7.92512 16.5012 7.87176 16.5012 7.80062C16.5012 7.71168 16.43 7.65833 16.3589 7.65833Z"
        fill="#F15C4F"
      />
      <path
        d="M16.4652 8.03186C16.4296 8.03186 16.394 8.06743 16.394 8.10301C16.394 8.13858 16.4296 8.17415 16.4652 8.17415C16.5008 8.17415 16.5363 8.13858 16.5363 8.10301C16.5363 8.06743 16.5008 8.03186 16.4652 8.03186Z"
        fill="#F15851"
      />
      <path
        d="M16.5723 6.23547C16.5011 6.23547 16.4478 6.28883 16.4478 6.35998C16.4478 6.43113 16.5189 6.48449 16.59 6.48449C16.6612 6.48449 16.7146 6.43113 16.7146 6.35998C16.6968 6.28883 16.6434 6.23547 16.5723 6.23547Z"
        fill="#F3724A"
      />
      <path
        d="M15.3269 5.06159C15.3269 4.95487 15.2558 4.88373 15.1491 4.88373C15.0601 4.88373 14.9712 4.97266 14.9712 5.06159C14.9712 5.16831 15.0423 5.23946 15.1491 5.23946C15.238 5.25725 15.3269 5.16831 15.3269 5.06159Z"
        fill="#F78F43"
      />
      <path
        d="M14.811 4.93693C14.811 4.9725 14.8466 5.00808 14.8822 5.00808C14.9178 5.00808 14.9533 4.9725 14.9533 4.93693C14.9533 4.90136 14.9178 4.86578 14.8822 4.86578C14.8466 4.86578 14.811 4.90136 14.811 4.93693Z"
        fill="#F79442"
      />
      <path
        d="M14.1352 4.22551C14.1352 4.08322 14.0285 3.9765 13.8862 3.9765C13.7439 3.9765 13.6372 4.08322 13.6372 4.22551C13.6372 4.36781 13.7439 4.47453 13.8862 4.47453C14.0285 4.49231 14.1352 4.36781 14.1352 4.22551Z"
        fill="#F57F33"
      />
      <path
        d="M9.93757 8.29871C9.88421 8.29871 9.84863 8.33428 9.84863 8.38764C9.84863 8.441 9.88421 8.47657 9.93757 8.47657C9.99092 8.47657 10.0265 8.441 10.0265 8.38764C10.0087 8.33428 9.97314 8.29871 9.93757 8.29871Z"
        fill="#2650A3"
      />
      <path
        d="M10.7023 10.5042C10.6133 10.5042 10.5244 10.433 10.5244 10.3263C10.5244 10.2374 10.5956 10.1484 10.7023 10.1484C10.7912 10.1484 10.8801 10.2196 10.8801 10.3263C10.8801 10.433 10.7912 10.5042 10.7023 10.5042Z"
        fill="#4D3F99"
      />
    </svg>
    <svg
      v-if="name==='altel'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="12"
        fill="#E12084"
      />
      <path
        d="M11.6577 10.8063V12.0334C11.6577 12.3681 11.5436 12.9631 11.9238 12.9259C12.4941 12.9631 12.1519 11.6988 12.266 10.8063C12.6842 10.7319 13.5206 10.955 13.5586 10.2857H10.4031C10.4411 10.9179 11.1254 10.8063 11.6577 10.8063Z"
        fill="white"
      />
      <path
        d="M3.74985 10.8435C3.55976 11.1782 2.57129 12.8515 2.57129 12.9631C3.25562 13.0002 3.25562 12.6656 3.52175 12.4425H4.92844C4.92844 12.2565 4.73834 12.0706 4.58626 11.9962C4.35815 11.9219 4.016 11.959 3.78788 11.959C3.78788 11.8103 4.28212 10.955 4.35816 10.8807C4.47222 10.955 4.96644 11.8847 5.0805 12.1078C5.34663 12.5912 5.46068 13.0002 6.14501 12.9631C6.10699 12.8515 5.15654 11.1782 4.96645 10.8435C4.81437 10.5832 4.73835 10.3229 4.35816 10.3229C3.97798 10.3229 3.90193 10.5832 3.74985 10.8435Z"
        fill="white"
      />
      <path
        d="M8.76829 12.9631C9.1865 12.9631 9.71874 13.0002 10.1369 12.9631C10.1369 12.554 9.75677 12.4796 9.33857 12.4796C8.9964 12.4796 8.35008 12.5168 8.04593 12.4796C7.9699 11.4013 8.31207 10.2857 7.43765 10.3229C7.39963 10.6947 7.43765 11.2153 7.43765 11.6244C7.43765 13.149 7.20954 12.9631 8.76829 12.9631Z"
        fill="white"
      />
      <path
        d="M15.3455 10.8435C15.4976 10.7691 16.7522 10.8063 16.9803 10.8063C17.2464 10.8063 17.4365 10.6204 17.4365 10.3229H15.4215C14.6231 10.3229 14.7372 10.3229 14.7372 11.6616C14.7372 12.9631 14.5851 12.9631 15.4215 12.9631H17.4365C17.4365 12.7771 17.3224 12.6284 17.2084 12.554C16.8662 12.3309 15.8017 12.554 15.3455 12.4425V11.8847H16.6001C16.6001 11.6244 16.448 11.5128 16.2579 11.4385L15.3455 11.4013C15.3075 11.2525 15.3075 10.9922 15.3455 10.8435Z"
        fill="white"
      />
      <path
        d="M21.4284 12.9631C21.4284 12.7399 21.2384 12.5168 21.0102 12.5168C20.554 12.4796 19.7176 12.554 19.3374 12.5168C19.2614 12.3309 19.2994 11.0666 19.2994 10.8063C19.3754 10.5088 19.0333 10.2857 18.7291 10.3229C18.6911 10.6947 18.7291 11.2153 18.7291 11.6244C18.7291 13.1862 18.539 12.9631 20.0598 12.9631C20.478 12.9631 21.0102 13.0002 21.4284 12.9631Z"
        fill="white"
      />
    </svg>
    <svg
      v-if="name==='beeline'"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3.09168 20.0389C6.32637 20.1305 9.98963 20.212 12.0407 20.212C14.0815 20.212 17.7039 20.1305 20.908 20.0389C22.1937 18.6134 23.1529 16.8722 23.6325 14.9375H0.367188C0.856983 16.862 1.80596 18.6032 3.09168 20.0389Z"
        fill="#F8D648"
      />
      <path
        d="M3.0918 20.0391C5.28567 22.4727 8.46935 24 12 24C15.5306 24 18.7142 22.4727 20.9081 20.0391C17.704 20.1307 14.0816 20.2122 12.0408 20.2122C9.99996 20.2122 6.32649 20.1307 3.0918 20.0391Z"
        fill="black"
      />
      <path
        d="M0 11.9955C0 13.0137 0.122448 13.9912 0.367346 14.9382H23.6327C23.8673 14.0014 24 13.0137 24 11.9955C24 10.9772 23.8673 9.9997 23.6327 9.05273H0.367346C0.132652 9.9997 0 10.9874 0 11.9955Z"
        fill="black"
      />
      <path
        d="M20.9081 3.96097C18.7142 1.52736 15.5306 0 12 0C8.46935 0 5.28567 1.52736 3.0918 3.96097C6.32649 3.86932 9.98975 3.78786 12.0408 3.78786C14.0816 3.78786 17.704 3.86932 20.9081 3.96097Z"
        fill="black"
      />
      <path
        d="M12.0407 3.78809C9.98963 3.78809 6.32637 3.86955 3.09168 3.96119C1.79576 5.38673 0.846779 7.12792 0.367188 9.06258H23.6325C23.1427 7.1381 22.1937 5.39691 20.908 3.96119C17.7039 3.86955 14.0815 3.78809 12.0407 3.78809Z"
        fill="#F8D648"
      />
    </svg>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    name: {
      type: String,
      default: ''
    }
  }
});
</script>
